import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import PropTypes from "prop-types";
import {
    Row,
    Col,
    Card,
    Button
    // Select
} from "antd";
import { FinancialYearSelector } from "components";
import AutoComputedRatioList from "./auto-computed-ratios";
import FinancialAnalysisForm from "./financial-analysis-form";
import {
    createdFinancialYear,
    fetchFinancialYears,
    fetchFinancials,
    updateFinancials,
    updateCaseDetail
} from "store/actions";
import "styles/financial-analysis-table.css";
import { STATE_STATUS } from "constants/index";
import { FinancialDetailRecord } from "records/index";
import FacilityServices from "services/facility-account-service";
import moment from "moment";
import * as XLSX from "xlsx";
import {TRADING_PROFIT_AND_LOSS, BALANCE_SHEET_ASSETS, BALANCE_SHEET_LIABILITIES} from "./financial-analysis-form"
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";

const financial_Analysis_Excel_Data_fn = (fyColumns) => [
    ["Trading Profit and Loss"],
    ["Year Ended", ...fyColumns],
    ["Sales", "", "", ""],
    ["Other Income", "", "", ""],
    ["Net Sales", "", "", ""],
    [],
    ["Raw Material Purchase", "", "", ""],
    ["Spare Purchase", "", "", ""],
    ["Total Purchase", "", "", ""],
    [],
    ["Opening Stock", "", "", ""],
    ["Closing Stock P&F", "", "", ""],
    ["Direct Expense", "", "", ""],
    ["COGS", "", "", ""],
    [],
    ["Gross Profit", "", "", ""],
    [],
    ["Salary To Staff", "", "", ""],
    ["Depreciation P&F", "", "", ""],
    ["Other Expenses", "", "", ""],
    ["Total Expense", "", "", ""],
    [],
    ["Interest Paid", "", "", ""],
    ["EBIDTA", "", "", ""],
    ["PBIT", "", "", ""],
    ["PBT", "", "", ""],
    ["Taxes", "", "", ""],
    ["PAT", "", "", ""],
    [],
    [], 
    ["Balance Sheet Liabilities"],
    ["Year Ended", ...fyColumns],
    ["Loan From Bank (CC/OD)", "", "", ""],
    ["Creditors", "", "", ""],
    ["Advances", "", "", ""],
    ["Provision (Tax & Other)", "", "", ""],
    ["Term Loan EMI Payable", "", "", ""],
    ["Other Liabilities", "", "", ""],
    ["Total Borrowings", "", "", ""],
    [],
    ["Term Loan", "", "", ""],
    ["Unsecured Loan", "", "", ""],
    ["Other Liabilities (> 1 Year)", "", "", ""],
    ["Total Borrowings (>1 Year)", "", "", ""],
    [],
    ["Equity", "", "", ""],
    ["Quasi Equity", "", "", ""],
    ["Tnw", "", "", ""],
    [],
    ["Tol", "", "", ""],
    ["Total Debt", "", "", ""],
    ["Total Liabilities", "", "", ""],
    [],
    [], 
    ["Balance Sheet Assets"],
    ["Year Ended", ...fyColumns],
    ["Cash & Bank Balance", "", "", ""],
    ["Investment (Current Asset)", "", "", ""],
    ["Debtors", "", "", ""],
    ["Closing Stock", "", "", ""],
    ["Advance Tax", "", "", ""],
    ["Loan And Advances", "", "", ""],
    ["Other Current Asset", "", "", ""],
    ["Total Current Asset", "", "", ""],
    [],
    ["Gross Block", "", "", ""],
    ["Depreciation", "", "", ""],
    ["Net Block", "", "", ""],
    [],
    ["Loans And Advances", "", "", ""],
    ["Debtor", "", "", ""],
    ["Deferred Taxes", "", "", ""],
    ["Investment (Non Current Asset)", "", "", ""],
    ["Other Non Current Asset", "", "", ""],
    ["Total Non Current Asset", "", "", ""],
    ["Total Asset", "", "", ""],
    [],
    ["Difference in BS", "", "", ""],
  ];

class FinancialAnalysisTab extends React.Component {
    state = {
        year: null,
        yearBefore: null
    };
    f1 = null;
    f2 = null;
    handleFinancialYearsFetch() {
        if (this.props.financialYearsStatus === STATE_STATUS.UNFETCHED) {
            this.props.fetchFinancialYears(this.props.companyId);
        }
    }
    handleFinancialsFetch() {
        if (
            !this.props.financialsStatus ||
            this.props.financialsStatus === STATE_STATUS.UNFETCHED
        ) {
            this.props.fetchFinancials(this.props.companyId);
        }
    }
    // shouldComponentUpdate(prevProps) {
    //     // if (
    //     //     this.props.financialsStatus === "UPDATING" &&
    //     //     prevProps.financialsStatus === "FETCHED"
    //     // ) {
    //     //     return false;
    //     // }
    //     return true;
    // }
    componentDidMount() {
        this.handleFinancialYearsFetch();
        this.handleFinancialsFetch();
        this.autoSelectFinancials();
    }
    componentDidUpdate() {
        this.handleFinancialYearsFetch();
        this.handleFinancialsFetch();
        this.autoSelectFinancials();
        if (
            this.state.year &&
            (this.props.caseDetail && !this.props.caseDetail.is_financial_analysis_applied)
        ) {
            this.props.updateCaseDetail(
                this.props.caseId,
                this.props.caseDetail.set("is_financial_analysis_applied", true)
            );
        }
    }
    autoSelectFinancials() {
        if (
            this.props.caseDetail &&
            this.props.caseDetail.is_financial_analysis_applied &&
            !this.state.year &&
            this.props.financialYearsStatus === STATE_STATUS.FETCHED &&
            this.props.financialsStatus === STATE_STATUS.FETCHED
        ) {
            const filteredFinancials = this.props.financials
                .filter(_ => _.is_active)
                .sort((f1, f2) => {
                    let momentDate = null;
                    if(moment.isMoment(f1.financial_year.start_date)){
                        momentDate = f1.financial_year.start_date;
                    }else{
                        momentDate = moment(f1.financial_year.start_date);
                    }
                    if (
                        momentDate.isAfter(
                            f2.financial_year.start_date
                        )
                    ) {
                        return -1;
                    }
                    return 1;
                });
            const f1 = filteredFinancials.get(0);
            const f2 = filteredFinancials.get(1);
            if (f1) {
                this.onFinancialYearSelect(
                    f1 && f1.financial_year,
                    f2 && f2.financial_year
                );
            }
        }
    }
    financialAnalysisConditionToggle = value => {
        this.props.updateCaseDetail(
            this.props.caseId,
            this.props.caseDetail.set("is_financial_analysis_applied", value)
        );
    };
    handleFinancialsSelect(year, yearBefore) {
        if (this.props.financialsStatus === STATE_STATUS.FETCHED && year) {
            const f1 = this.props.financials.find(
                _ => _.financial_year.id == (year && year.id)
            );
            const f2 = this.props.financials.find(
                _ => _.financial_year.id == (yearBefore && yearBefore.id)
            );
            this.f1 =
                f1 ||
                new FinancialDetailRecord({
                    case: this.props.caseId,
                    company: this.props.companyId,
                    financial_year: year,
                    is_active: true
                });
            this.f2 =
                f2 ||
                new FinancialDetailRecord({
                    case: this.props.caseId,
                    company: this.props.companyId,
                    financial_year: yearBefore,
                    is_active: true
                });
        }
    }
    onFinancialYearSelect = (year, yearBefore) => {
        if (year === "disable") {
            this.props.updateCaseDetail(
                this.props.caseId,
                this.props.caseDetail.set(
                    "is_financial_analysis_applied",
                    false
                )
            );
            this.setState({
                year: null,
                yearBefore: null
            });
            return;
        }
        this.setState({
            year,
            yearBefore
        });
    };
    save = (f1, f2) => {
        let is_f1_found = false,
            is_f2_found = false;
        let financials = this.props.financials.map(_ => {
            if (f1.id === _.id) {
                is_f1_found = true;
                return f1.set("is_active", true);
            }
            if (f2.id === _.id) {
                is_f2_found = true;
                return f2.set("is_active", true);
            }
            return _.set("is_active", false);
        });
        if (!is_f1_found) {
            financials = financials.push(f1.set("is_active", true));
        }
        if (!is_f2_found && f2.financial_year) {
            financials = financials.push(f2.set("is_active", true));
        }
        console.log("inside financials", financials);
        const idSubmition = {
            "financial_year_id": f1.toJS()?.financial_year?.id
        };
            FacilityServices.SubmitFinYearId(idSubmition, this.props.caseId).then((data) => {
                console.log("data", data);
            }).catch((err) => {
                console.log("err", err);
            });
        this.props.updateFinancials(this.props.companyId, financials.toArray());
    };

    getFinancialYears = () => {
        const currentYear = new Date().getFullYear();
        const currentMonth = new Date().getMonth() + 1; // 0-based
        const fyEndYear = currentMonth >= 4 ? currentYear + 1 : currentYear; // FY ends in March
        const fyStartYear = fyEndYear - 1;
      
        const financialYears = [];
        for (let i = 3; i >= 0; i--) {
          const start = fyStartYear - i;
          const end = fyEndYear - i;
          financialYears.push(`FY ${start}–${String(end).slice(2)}`);
        }
        return financialYears;
      };
      
    fyColumns = this.getFinancialYears();

    downloadTemplate = async () => {
        const workbook = new ExcelJS.Workbook();
        const sheet = workbook.addWorksheet("Financial Report");

        const yellow = { type: "pattern", pattern: "solid", fgColor: { argb: "FFFFCC00" } };

        const markCalculated = (cell) => {
            if (!cell) return;
            cell.fill = yellow;
            cell.protection = { locked: true };
        };

        const markEditable = (cell) => {
            if (!cell) return;
            cell.protection = { locked: false };
        };

        // const baseRows = financial_Analysis_Excel_Data_fn(this.fyColumns);
        const ws = sheet;
        const fyCols = this.fyColumns;
        const totalCols = 1 + fyCols.length;

        const baseRows = financial_Analysis_Excel_Data_fn(fyCols).map((row) => {
            const copy = Array.from(row || []);
            while (copy.length < totalCols) copy.push("");
            return copy;
        });

        baseRows.forEach((rowArray) => {
            const rowRef = sheet.addRow(rowArray);
            const labelCell = rowRef.getCell(1);
            labelCell.protection = { locked: true };
            labelCell.font = { bold: true };

            for (let c = 2; c <= totalCols; c += 1) {
                const cell = rowRef.getCell(c);
                markEditable(cell);
            }
        });

        ws.columns = [{ width: 35 }, ...this.fyColumns.map(() => ({ width: 15 }))];
        const getExcelColumn = (index) => {
            let dividend = index;
            let columnName = "";
            let modulo;
            while (dividend > 0) {
                modulo = (dividend - 1) % 26;
                columnName = String.fromCharCode(65 + modulo) + columnName;
                dividend = Math.floor((dividend - modulo) / 26);
            }
            return columnName;
        };

        this.fyColumns.forEach((_, fyIdx) => {
            const colIndex = 2 + fyIdx;
            const col = getExcelColumn(colIndex);

            // P&L section
            ws.getCell(`${col}5`).value = { formula: `IF(OR(${col}3="",${col}4=""),"",${col}3+${col}4)` };      // Net Sales
            ws.getCell(`${col}9`).value = { formula: `IF(OR(${col}7="",${col}8=""),"",${col}7+${col}8)` };      // Total Purchase
            ws.getCell(`${col}14`).value = { formula: `IF(OR(${col}11="",${col}9="",${col}13="",${col}12=""),"",${col}11+${col}9+${col}13-${col}12)` }; // COGS
            ws.getCell(`${col}16`).value = { formula: `IF(OR(${col}5="",${col}14=""),"",${col}5-${col}14)` };    // Gross Profit
            ws.getCell(`${col}21`).value = { formula: `IF(OR(${col}18="",${col}19="",${col}20=""),"",${col}18+${col}19+${col}20)` }; // Total Expense
            ws.getCell(`${col}24`).value = { formula: `IF(OR(${col}19="",${col}25=""),"",${col}19+${col}25)` };  // EBIDTA
            ws.getCell(`${col}25`).value = { formula: `IF(OR(${col}16="",${col}18="",${col}19="",${col}20=""),"",${col}16-${col}18-${col}19-${col}20)` }; // PBIT
            ws.getCell(`${col}26`).value = { formula: `IF(OR(${col}25="",${col}23=""),"",${col}25-${col}23)` };  // PBT
            ws.getCell(`${col}28`).value = { formula: `IF(OR(${col}26="",${col}27=""),"",${col}26-${col}27)` };  // PAT

            // Liabilities
            ws.getCell(`${col}39`).value = { formula: `IF(OR(${col}33="",${col}34="",${col}35="",${col}36="",${col}37="",${col}38=""),"",${col}33+${col}34+${col}35+${col}36+${col}37+${col}38)` }; //total borrowings < 1
            ws.getCell(`${col}44`).value = { formula: `IF(OR(${col}41="",${col}42="",${col}43=""),"",${col}41+${col}42+${col}43)` }; //total borrowings > 1
            ws.getCell(`${col}48`).value = { formula: `IF(OR(${col}46="",${col}47=""),"",${col}46+${col}47)` };   // Tnw
            ws.getCell(`${col}50`).value = { formula: `IF(OR(${col}39="",${col}44=""),"",${col}39+${col}44)` };   // Tol
            ws.getCell(`${col}51`).value = { formula: `IF(OR(${col}33="",${col}41="",${col}42="",${col}43=""),"",${col}33+${col}41+${col}42+${col}43)` }; // Total Debt
            ws.getCell(`${col}52`).value = { formula: `IF(OR(${col}39="",${col}44="",${col}48=""),"",${col}39+${col}44+${col}48)` }; // Total Liabilities

            // Assets
            ws.getCell(`${col}64`).value = { formula: `IF(OR(${col}57="",${col}58="",${col}59="",${col}60="",${col}61="",${col}62="",${col}63=""),"",${col}57+${col}58+${col}59+${col}60+${col}61+${col}62+${col}63)` }; // Total Current Asset
            ws.getCell(`${col}68`).value = { formula: `IF(OR(${col}66="",${col}67=""),"",${col}66-${col}67)` }; // Net Block
            ws.getCell(`${col}75`).value = { formula: `IF(OR(${col}70="",${col}71="",${col}72="",${col}73="",${col}74=""),"",${col}70+${col}71+${col}72+${col}73+${col}74)` }; // Total Non Current Asset
            ws.getCell(`${col}76`).value = { formula: `IF(OR(${col}64="",${col}68="",${col}75=""),"",${col}64+${col}68+${col}75)` }; // Total Asset
            ws.getCell(`${col}78`).value = { formula: `IF(OR(${col}76="",${col}52=""),"",${col}76-${col}52)` }; // Difference in BS

            [
                5, 9, 14, 16, 21, 24, 25, 26, 28, 39, 44, 48, 50, 51, 52, 64, 68, 75, 76, 78,
            ].forEach((r) => {
                const cell = ws.getCell(`${col}${r}`);
                markCalculated(cell);
            });
        });

        // await ws.protect("1234", {
        //     selectLockedCells: true,
        //     selectUnlockedCells: true,
        // });

        const buffer = await workbook.xlsx.writeBuffer();
        saveAs(new Blob([buffer]), "financial_report_template.xlsx");
    };


    handleFileUpload = (e) => {
        const file = e.target.files?.[0];
        if (!file) return;

        const reader = new FileReader();

        e.target.value = "";

        const normalizeLabel = (s) =>
            (s || "")
                .toString()
                .replace(/\u2013|\u2014|–/g, "-")
                .replace(/[^\S\r\n]+/g, " ")
                .trim()
                .toLowerCase();

        const buildLabelMap = () => {
            const labelMap = {};
            const mergeMap = (map) => {
                map.forEach((value, key) => {
                    if (value.label) {
                        const norm = normalizeLabel(value.label);
                        labelMap[norm] = key;
                    }
                });
            };
            mergeMap(TRADING_PROFIT_AND_LOSS);
            mergeMap(BALANCE_SHEET_LIABILITIES);
            mergeMap(BALANCE_SHEET_ASSETS);
            return labelMap;
        };

        const labelToKeyMap = buildLabelMap();

        reader.onload = (event) => {
            const workbook = XLSX.read(new Uint8Array(event.target.result), { type: "array" });
            const worksheet = workbook.Sheets[workbook.SheetNames[0]];
            const sheetData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

            const headerRowIndex = sheetData.findIndex((row) =>
                row.some((cell) => normalizeLabel(cell) === "year ended")
            );
            if (headerRowIndex === -1) {
                return;
            }

            const headers = sheetData[headerRowIndex];
            const fyColumns = headers.slice(1).map((h) => (h || "").trim());
            const dataRows = sheetData.slice(headerRowIndex + 1);

            const finalData = {};
            fyColumns.forEach((fy) => (finalData[fy] = {}));
            const unmatchedLabels = new Set();

            dataRows.forEach((row) => {
                const rawLabel = row[0];
                if (!rawLabel?.trim()) return;

                const key = labelToKeyMap[normalizeLabel(rawLabel)];
                if (!key) {
                    unmatchedLabels.add(rawLabel);
                    return;
                }

                fyColumns.forEach((fy, idx) => {
                    const value = row[idx + 1];
                    if (
                        value !== undefined &&
                        value !== null &&
                        String(value).trim() !== "" &&
                        key !== "financial_year"
                    ) {
                        finalData[fy][key] = value;
                    }
                });
            });

            const normalizeFyName = (fy) =>
                (fy || "")
                    .replace(/\u2013|\u2014|–/g, "-")
                    .replace(/[^0-9]/g, "")
                    .trim();

            const canonicalFy = (fy) => "FY" + normalizeFyName(fy);
            const canonicalMap = {};
            Object.keys(finalData).forEach((fy) => (canonicalMap[canonicalFy(fy)] = fy));

            const fy1 = this.f1.getIn(["financial_year", "name"]);
            const fy2 = this.f2.getIn(["financial_year", "name"]);
            const fy1Key = canonicalMap[canonicalFy(fy1)];
            const fy2Key = canonicalMap[canonicalFy(fy2)];

            const fy1Data = finalData[fy1Key] || {};
            const fy2Data = finalData[fy2Key] || {};

            const updatedF1 = this.f1.merge(fy1Data);
            const updatedF2 = this.f2.merge(fy2Data);

            let is_f1_found = false,
                is_f2_found = false;
            let financials = this.props.financials.map((f) => {
                if (f.id === updatedF1.id) {
                    is_f1_found = true;
                    return updatedF1.set("is_active", true);
                }
                if (f.id === updatedF2.id) {
                    is_f2_found = true;
                    return updatedF2.set("is_active", true);
                }
                return f.set("is_active", false);
            });

            if (!is_f1_found) financials = financials.push(updatedF1.set("is_active", true));
            if (!is_f2_found && updatedF2.financial_year)
                financials = financials.push(updatedF2.set("is_active", true));
            const idSubmission = {
                financial_year_id: this.f1.toJS()?.financial_year?.id,
            };

            FacilityServices.SubmitFinYearId(idSubmission, this.props.caseId)
                .then((data) => console.log(" FY submitted:", data))
                .catch((err) => console.error(" FY submission error:", err));

            this.props.updateFinancials(this.props.companyId, financials.toArray());
        };

        reader.readAsArrayBuffer(file);
    };

      
    render() {
        this.handleFinancialsSelect(this.state.year, this.state.yearBefore);
        return (
            <React.Fragment>
                {/* <Row className={"p-5"}>
                    <Col span={24} className={"p-10"}>
                        <Card>
                            <div
                                className={
                                    "d-flex justify-content-space-between"
                                }
                            >
                                <h3>Is Financial Analysis applied?</h3>
                                <Select
                                    value={String(
                                        this.props.caseDetail
                                            .is_financial_analysis_applied
                                    )}
                                    onSelect={
                                        this.financialAnalysisConditionToggle
                                    }
                                    style={{ width: "200px" }}
                                >
                                    <Select.Option value={"true"}>
                                        Yes
                                    </Select.Option>
                                    <Select.Option value={"false"}>
                                        No
                                    </Select.Option>
                                </Select>
                            </div>
                        </Card>
                    </Col>
                </Row> */}
                <Row className={"p-5"}>
                    <Col
                        span={12}
                        className={"d-flex justify-content-space-between p-10"}
                    >
                        <h2> Financial Years </h2>
                        <div className="d-flex">
                            <Button type="primary" onClick={this.downloadTemplate} className="mr-5">
                                Download Excel Template
                            </Button>
                            <input
                                type="file"
                                accept=".xlsx, .xls"
                                onChange={this.handleFileUpload}
                                className="mt-4"
                            />
                        </div>
                    </Col>
                    <Col
                        span={12}
                        className={"d-flex justify-content-space-between p-10"}
                    >
                        <FinancialYearSelector
                            financialYears={this.props.financialYears}
                            onFinancialYearSelect={this.onFinancialYearSelect}
                            year={this.state.year}
                            disabled={
                                !this.props.caseDetail ||
                                !this.props.caseDetail
                                    .is_financial_analysis_applied
                            }
                            isRiskApprover={this.props.isRiskApprover}
                        />
                    </Col>
                    <Col span={16} className={"p-10"}>
                        <Row className={"p-5"}>
                            <Col span={24} className={"p-10"}>
                                <FinancialAnalysisForm
                                    formName="TradingProfitAndLoss"
                                    f1={this.f1}
                                    f2={this.f2}
                                    save={this.save}
                                    title={"Trading Profit and Loss"}
                                    recreditViewOnlyPermission={this.props.recreditViewOnlyPermission}
                                />
                            </Col>
                            <Col span={24} className={"p-10"}>
                                <FinancialAnalysisForm
                                    formName="BalanceSheetLiabilitiesForm"
                                    f1={this.f1}
                                    f2={this.f2}
                                    save={this.save}
                                    title={"Balance Sheet Liabilities"}
                                    recreditViewOnlyPermission={this.props.recreditViewOnlyPermission}
                                />
                            </Col>
                            <Col span={24} className={"p-10"}>
                                <FinancialAnalysisForm
                                    formName="BalanceSheetAssetsForm"
                                    f1={this.f1}
                                    f2={this.f2}
                                    save={this.save}
                                    title={"Balance Sheet Assets"}
                                    recreditViewOnlyPermission={this.props.recreditViewOnlyPermission}
                                />
                            </Col>
                        </Row>
                    </Col>
                    <Col span={8} className={"p-10"}>
                        <Row className={"p-5"}>
                            <Col span={24} className={"p-10"}>
                                <Card className={"padless-card mb-10"}>
                                    <AutoComputedRatioList
                                        name="ratios"
                                        f1={this.f1}
                                        f2={this.f2}
                                    />
                                </Card>
                            </Col>
                            <Col span={24} className={"p-10"}>
                                <Card className={"padless-card"}>
                                    <AutoComputedRatioList
                                        name="dscr"
                                        f1={this.f1}
                                        f2={this.f2}
                                    />
                                </Card>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </React.Fragment>
        );
    }
}

FinancialAnalysisTab.propTypes = {
    companyId: PropTypes.number,
    caseId: PropTypes.number,
    caseDetail: PropTypes.object,
    caseDetailStatus: PropTypes.string,
    financialYearsStatus: PropTypes.string,
    financialYears: PropTypes.object,
    financialsStatus: PropTypes.string,
    financials: PropTypes.object,
    createdFinancialYear: PropTypes.func,
    fetchFinancialYears: PropTypes.func,
    updateFinancials: PropTypes.func,
    updateCaseDetail: PropTypes.func,
    fetchFinancials: PropTypes.func,
    isRiskApprover: PropTypes.bool,
    recreditViewOnlyPermission: PropTypes.bool,
};

FinancialAnalysisTab.defaultProps = {
    isRiskApprover: false
};

const mapStateToProps = (state, props) => ({
    financialYearsStatus: state.financials.get("financialYearsStatus"),
    financialYears: state.financials.get("financialYears"),
    financialsStatus: state.financials.getIn([
        "list",
        props.companyId,
        "status"
    ]),
    financials: state.financials.getIn(["list", props.companyId, "data"])
});

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            createdFinancialYear,
            fetchFinancialYears,
            updateFinancials,
            updateCaseDetail,
            fetchFinancials
        },
        dispatch
    );

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(FinancialAnalysisTab);
